import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

/**
 * The workspace's own AI key. Verified and stored server-side; the key itself
 * never comes back to the browser — only whether one is configured, the last
 * four characters, and whether it still works.
 */
export async function setWorkspaceAiKey(workspaceId, apiKey) {
  const res = await httpsCallable(functions, 'setWorkspaceAiKey')({ workspaceId, apiKey });
  return res?.data || { success: false, error: 'No response.' };
}

export async function getWorkspaceAiKeyStatus(workspaceId) {
  try {
    const res = await httpsCallable(functions, 'getWorkspaceAiKeyStatus')({ workspaceId });
    return res?.data || { configured: false };
  } catch {
    return { configured: false };
  }
}

export async function removeWorkspaceAiKey(workspaceId) {
  const res = await httpsCallable(functions, 'removeWorkspaceAiKeyFn')({ workspaceId });
  return res?.data || { success: false };
}

/**
 * The workspace's monthly AI ceiling.
 *
 * Separate from the per-step caps on agent nodes: those stop one runaway task,
 * this stops twenty well-behaved ones arriving at once — which is the shape a
 * surprise bill actually takes.
 */
export async function getAiSpend(workspaceId) {
  const res = await httpsCallable(functions, 'getAiSpend')({ workspaceId });
  return res?.data || null;
}

export async function setAiSpendCap(workspaceId, capUsd) {
  const res = await httpsCallable(functions, 'setAiSpendCap')({ workspaceId, capUsd });
  return res?.data || null;
}
